import dayjs from "dayjs";
import { StyledProductMeta } from "./ProductMeta.styles";
import { Product } from "@shopify/hydrogen/dist/esnext/storefront-api-types";
import { ComponentProps } from "react";

export interface ProductMetaProps
  extends Pick<Product, "publishedAt" | "tags">,
    Omit<
      ComponentProps<typeof StyledProductMeta>,
      "children" | "hasMotion" | "size"
    > {}

const ProductMeta = ({ publishedAt, tags, ...props }: ProductMetaProps) => (
  <StyledProductMeta {...props} hasMotion size="label-val">
    {`${tags.length > 0 ? `${tags[0]} ` : ""}${dayjs(publishedAt).format(
      "DDMMYYYY"
    )}`}
  </StyledProductMeta>
);

export default ProductMeta;
